/**
 * Endpoint methods related to Licenses
*/

import API from "./Api";

export default {
  /**
   * Gets all the Licenses related to the logged-In Instance
   */
  async getAllOwnLicenses() {

    return API.get("/licenses/getallown", "COOKIE_TOKEN_SESSION");
  },
};
